const UserSegmentApp = () => import(/* webpackChunkName: "UserSegmentApp" */ './containers/UserSegmentApp');
const UserSegmentList = () => import(/* webpackChunkName: "UserSegmentList" */ './containers/UserSegmentList');
const UserSegmentPlayers = () => import(/* webpackChunkName: "UserSegmentPlayers" */ './containers/UserSegmentPlayers');

export const userSegmentRouting = [
    {
        path: 'user-segment', name: 'user-segment', component: UserSegmentApp,
        children: [
            { path: '/', redirect: 'user-segment-list' },
            { path: 'user-segment-list', name: 'user-segment-list', component: UserSegmentList },
            { path: 'user-segment-players/:id', name: 'user-segment-players', component: UserSegmentPlayers }
        ]
    }
]